import { useState } from 'react';
import { env } from '../../config/env';
import '../../assets/css/theme.css';
import '../../assets/css/landing.css';

const Video = () => {
  const [isPlaying, setIsPlaying] = useState(false);

  const handlePlayClick = () => {
    setIsPlaying(true);
  };

  return (
    <section className="ffh-video">
      <div className="ffh-container">
        <div className="ffh-section-head">
          <p className="ffh-eyebrow">The Story</p>
          <h2 className="ffh-title">Fashion Frame <em>in motion</em></h2>
        </div>

        <div className="ffh-video-frame">
          {!isPlaying && (
            <div className="ffh-video-poster">
              <img src={require('../../assets/images/video-image.jpg')} alt="Classic Collection" />
              <div className="ffh-video-shade" />

              <button type="button" className="ffh-video-play" onClick={handlePlayClick} aria-label="Play video">
                <svg viewBox="0 0 100 100" className="ffh-video-ring" aria-hidden="true">
                  <defs>
                    <path id="ffh-video-circle" d="M 50,50 m -38,0 a 38,38 0 1,1 76,0 a 38,38 0 1,1 -76,0" />
                  </defs>
                  <text>
                    <textPath href="#ffh-video-circle" textLength="232" lengthAdjust="spacing">
                      FASHION FRAME 2025 · FASHION FRAME 2025 ·
                    </textPath>
                  </text>
                </svg>
                <span className="ffh-video-btn">
                  <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" width="26" height="26" style={{ marginLeft: 3 }}>
                    <path d="M8 5v14l11-7z" fill="currentColor" />
                  </svg>
                </span>
              </button>

              <div className="ffh-video-caption">
                <strong>Classic Collection</strong>
                <span>Watch the film</span>
              </div>
            </div>
          )}

          {isPlaying && (
            <div className="ffh-video-embed">
              <iframe
                width="100%"
                height="600"
                src={`${env.promoVideoEmbedUrl}?autoplay=1`}
                title="YouTube video player"
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
              ></iframe>
            </div>
          )}
        </div>
      </div>
    </section>
  );
};

export default Video;